import React from 'react';
import PropTypes from 'prop-types';

import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Result from '@Components/Results/Result';
import RsTableRow from '@Pages/RetroSynthesis/components/RsTable/RsTableRow';
import { Checkbox } from '@els/els-react--checkbox';
import cn from 'classnames';

import './ExamplesTableItem.scss';

function ExamplesTableItem({ exampleNo, reactionId, score, metadata, result, isVisible, isChecked, setChecked }) {
  return (
    <RsTableRow className={cn('examples-table-item', { 'not-visible': !isVisible })}>
      <td className="c-els-table__cell c-els-table__basic-cell">
        <div className="result-checkbox-container">
          <Checkbox
            data-e2e={`examples-table-item-checkbox-${exampleNo}`}
            id={`element${exampleNo}`}
            label={`Select example number ${exampleNo}`}
            shouldHideLabel
            checked={isChecked}
            onChange={() => setChecked(reactionId, !isChecked)}
          />
          <div className="result-checkbox-container__index u-els-font-size-meta u-els-color-n8 u-els-text-center">{exampleNo}</div>
        </div>
      </td>
      <td className="table-row__score c-els-table__cell c-els-table__basic-cell">{score}</td>
      <td className="table-row__reaction c-els-table__cell c-els-table__basic-cell">
        <div className="examples-table-item__reaction rx-list rx-list--reactions">
          {result ? (
            <Result
              key={result.id}
              context="reactions"
              hideCheckbox
              result={result}
              metadata={{
                ...metadata,
                expandConditions: exampleNo === 1,
                fromRT: true,
              }}
            />
          ) : (
            <SimpleSpinner className="examples-table-item__reaction-loader rx-loader--container__relative" />
          )}
        </div>
      </td>
    </RsTableRow>
  );
}

ExamplesTableItem.propTypes = {
  exampleNo: PropTypes.number,
  reactionId: PropTypes.string,
  score: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  metadata: PropTypes.object,
  result: PropTypes.object,
  isVisible: PropTypes.bool,
  isChecked: PropTypes.bool,
  setChecked: PropTypes.func,
};

export default ExamplesTableItem;
